
const COMPONENT_NAME = "z-collapse" ;
import { translateElement } from "../../util/locales" ;

export default function register(){
    
    const css = `
    z-collapse header {
        cursor: pointer
    }
    z-collapse section {
        overflow:hidden;
        transition:height 0.3s ease-out;
        height:auto;
        width: auto;
    }
    z-collapse.show section {
        width: auto;
    }

    z-collapse .z-collapse-caret {
        transition: transform 0.5s ;
    }
    z-collapse.show>header .z-collapse-caret {
        transform: rotate(180deg);
    }
    ` ;

    
    class CollapseComponent extends HTMLElement {
        constructor() {
            super();

            this.createCss() ;
            
            this.header = this.querySelector("header") ;
            this.contents = this.querySelector("section") ;

            if(!this.classList.contains("show") && this.contents){
                this.contents.setAttribute('data-collapsed', 'true');
                this.contents.style.height = 0 ;
            }
            if(this.header){
                this.header.addEventListener("click", ()=>{
                    this.toggle();
                }) ;
            }
        }

        connectedCallback(){
            this.createCss() ;
            translateElement(this) ;
        }

        createCss() {
            const rootNode = this.getRootNode();
            if(!rootNode || !rootNode.getElementById){ return ; }
            const styleTag = rootNode.getElementById("style_z_collapse") ;
            if(styleTag){ return ; }
            var s = document.createElement('style');
            s.id = "style_z_collapse" ;
            s.setAttribute('type', 'text/css');
            s.appendChild(document.createTextNode(css));
            rootNode.appendChild(s);
        }

        static get observedAttributes() {
            return ['class'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'class':
                    if(newValue !== this.currentValue){
                        this.applyClass() ;
                    }
                break;
            }
        }

        applyClass(){
            const isCollapsed = this.contents.getAttribute('data-collapsed') === 'true';
            if(this.classList.contains("show")){
                if(isCollapsed){this._doExpand() ;}
            }else{
                if(!isCollapsed){this._doCollapse() ;}
            }
        }
        
        toggle(){
            if(this.classList.contains("show")){
                this.classList.remove("show");
                this.dispatchEvent(new CustomEvent("hide"));
            }else{
                this.classList.add("show");
                this.dispatchEvent(new CustomEvent("show"));
            }
        }

        collapse(){
            this.classList.remove("show");
        }
        expand(){
            this.classList.add("show");
        }

        //logic from https://css-tricks.com/using-css-transitions-auto-dimensions/

        _doCollapse(){
            const element = this.contents ;
            // get the height of the element's inner content, regardless of its actual size
            const sectionHeight = element.scrollHeight;
            
            // temporarily disable all css transitions
            const elementTransition = element.style.transition;
            element.style.transition = '';
            
            // on the next frame (as soon as the previous style change has taken effect),
            // explicitly set the element's height to its current pixel height, so we 
            // aren't transitioning out of 'auto'
            requestAnimationFrame(function() {
                element.style.height = sectionHeight + 'px';
                element.style.transition = elementTransition;
                
                // on the next frame (as soon as the previous style change has taken effect),
                // have the element transition to height: 0
                requestAnimationFrame(function() {
                element.style.height = 0 + 'px';
                });
            });
            
            // mark the section as "currently collapsed"
            element.setAttribute('data-collapsed', 'true');
        }

        _doExpand(){
            const element = this.contents;

            // get the height of the element's inner content, regardless of its actual size
            const sectionHeight = element.scrollHeight;
            
            // have the element transition to the height of its inner content
            element.style.height = sectionHeight + 'px';
            
            // when the next css transition finishes (which should be the one we just triggered)
            const afterTransition= function() {
                // remove this event listener so it only gets triggered once
                element.removeEventListener('transitionend', afterTransition);
                
                // remove "height" from the element's inline styles, so it can return to its initial value
                element.style.height = null;
            };
            element.addEventListener('transitionend', afterTransition);
            
            // mark the section as "currently not collapsed"
            element.setAttribute('data-collapsed', 'false');
        }
    }
    customElements.define(COMPONENT_NAME, CollapseComponent);

}
